/**
 * Estados del sistema SOLCERT.
 */
export class StateSolcert {
  public static readonly CREATE = 200;
  public static readonly PENDING = 205;
  public static readonly ATTEND = 210;
  public static readonly OBSERVED = 215;
  public static readonly CANCEL = 220;
  public static readonly REFUSED = 240;
}
